import { registerLicense } from '@syncfusion/ej2-base';

// Register Syncfusion license as a side-effect module.
// This must run before any Syncfusion components/modules initialize.
registerLicense(
  'Ngo9BigBOggjHTQxAR8/V1JGaF5cXGpCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdlWXxfeHVSQ2dYUkN+W0BWYEs='
);
